// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().name("player_id"),
  accountId: __t.string().name("account_id"),
  displayName: __t.string().name("display_name"),
  guildName: __t.option(__t.string()).name("guild_name"),
  level: __t.u32(),
  xp: __t.u64(),
  currentInstanceId: __t.string().name("current_instance_id"),
  currentMapId: __t.string().name("current_map_id"),
  channelId: __t.string().name("channel_id"),
  mapX: __t.i32().name("map_x"),
  mapY: __t.i32().name("map_y"),
  prevMapX: __t.i32().name("prev_map_x"),
  prevMapY: __t.i32().name("prev_map_y"),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32().name("max_hp"),
  mana: __t.i32(),
  maxMana: __t.i32().name("max_mana"),
  stamina: __t.i32(),
  maxStamina: __t.i32().name("max_stamina"),
  statusJson: __t.string().name("status_json"),
  queueJson: __t.string().name("queue_json"),
  inventoryCapacity: __t.u32().name("inventory_capacity"),
  storageCapacity: __t.u32().name("storage_capacity"),
  moveDistance: __t.i32().name("move_distance"),
  viewRadius: __t.u32().name("view_radius"),
  isOnline: __t.bool().name("is_online"),
  updatedAt: __t.timestamp().name("updated_at"),
});
